import leads from './leads'
import rewards from './rewards'
import dashboard from './dashboard'
import leaderboard from './leaderboard'
import program from './program'

export default {
  homeMenu: {
    name: 'My Referrals',
    desc: 'Make referrals, check referral progress, earn and redeem rewards',
    noReferralPremiumDesc: 'Make referrals'
  },
  rewards,
  leads,
  dashboard,
  leaderboard,
  program
}
